import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["className"];
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { jsx as _jsx } from "react/jsx-runtime";
export default function UIMediaBody(props) {
  const {
      className
    } = props,
    rest = _objectWithoutPropertiesLoose(props, _excluded);
  return /*#__PURE__*/_jsx("div", Object.assign({}, rest, {
    className: classNames("media-body private-media__body", className)
  }));
}
UIMediaBody.displayName = 'UIMediaBody';
UIMediaBody.propTypes = {
  children: PropTypes.node
};